import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/login_pic.png';
const _withScopeId = n => (_pushScopeId("data-v-6377a594"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "login-container",
  ref: "container"
};
const _hoisted_2 = {
  class: "login-modal"
};
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"login-bg\" data-v-6377a594><img src=\"" + _imports_0 + "\" alt=\"\" srcset=\"\" data-v-6377a594><div class=\"hint\" data-v-6377a594>凭<span style=\"color:#ff2b26;\" data-v-6377a594>身份证号码</span>登录，首次登录的默认密码<span style=\"color:#ff2b26;\" data-v-6377a594>&quot;123456&quot;</span></div></div>", 1);
const _hoisted_4 = {
  class: "login-modal-content"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "用户登录", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "username"
}, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "password"
}, null, -1));
const _hoisted_8 = {
  class: "check-wrapper"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "checkbox"
}, "记住密码", -1));
const _hoisted_10 = {
  key: 0,
  style: {
    "color": "red",
    "margin-left": "20px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("form", null, [_createElementVNode("div", null, [_hoisted_6, _withDirectives(_createElementVNode("input", {
    type: "text",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.username = $event),
    id: "username",
    name: "username",
    autocomplete: "off",
    placeholder: "请输入用户名"
  }, null, 512), [[_vModelText, $data.form.username]])]), _createElementVNode("div", null, [_hoisted_7, _withDirectives(_createElementVNode("input", {
    type: "password",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.password = $event),
    id: "password",
    name: "password",
    placeholder: "请输入密码"
  }, null, 512), [[_vModelText, $data.form.password]])]), _createElementVNode("div", _hoisted_8, [_withDirectives(_createElementVNode("input", {
    type: "checkbox",
    id: "checkbox",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.isSavePsw = $event),
    class: "check"
  }, null, 512), [[_vModelCheckbox, $data.isSavePsw]]), _hoisted_9, $data.errorMsg ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString($data.errorMsg), 1)) : _createCommentVNode("", true)]), _createElementVNode("button", {
    onClick: _cache[3] || (_cache[3] = _withModifiers((...args) => $options.submit && $options.submit(...args), ["prevent"]))
  }, "登录")])])]), _createElementVNode("div", {
    class: "overlay",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.close && $options.close(...args))
  })], 512);
}